var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as moment from 'moment';
import { getScoreSystem } from '@crimp/lib-score-systems';
import ModalScoreSystemExplanation from './ModalScoreSystemExplanation';
var selfStyles = require('./styles.scss');
var ContentExplanations = (function (_super) {
    __extends(ContentExplanations, _super);
    function ContentExplanations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentExplanations.prototype.componentDidMount = function () {
        var _this = this;
        this.timer = window.setInterval(function () {
            _this.forceUpdate();
        }, 30000);
    };
    ContentExplanations.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    ContentExplanations.prototype.render = function () {
        var dateStart = moment(this.props.round.dateStart);
        var dateEnd = moment(this.props.round.dateEnd);
        var dateNow = moment();
        var isBefore = dateStart.isAfter(dateNow);
        var isEnded = dateEnd.isBefore(dateNow);
        var isNow = !isBefore && !isEnded;
        var scoreSystem = getScoreSystem(this.props.round.scoreSystem);
        var isGravicalTeamHack = this.props.round.eventId === 'ba322ae2-9b71-4bcc-af2b-70f328c70b2c' || 'cfa03e10-92b1-4e3d-b32c-45299cbbf092';
        return (React.createElement("div", { className: selfStyles.explanations },
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("strong", null, dateStart.format('MMM D (ddd) h.mma')),
                    " to ",
                    React.createElement("strong", null, dateEnd.format('MMM D (ddd) h.mma')),
                    React.createElement("ul", null,
                        isBefore && React.createElement("li", null,
                            "Round will start in ",
                            dateStart.fromNow(true)),
                        isEnded && React.createElement("li", null, "The round has ended!"),
                        isNow && React.createElement("li", null, "We're climbing now! See the live scores!"))),
                React.createElement("li", null,
                    "Score format: ",
                    React.createElement("strong", null, scoreSystem.name),
                    " ",
                    React.createElement(ModalScoreSystemExplanation, { round: this.props.round, scoreSystemName: scoreSystem.name })),
                !!this.props.category.isTeamCategory && !isGravicalTeamHack &&
                    (this.props.round.teamMultiplier === 1
                        ? React.createElement("li", null,
                            "Male/Female athletes will be ",
                            React.createElement("strong", null, "credited equally"),
                            " for their team")
                        : React.createElement("li", null,
                            "Female athletes will receive ",
                            React.createElement("strong", null,
                                this.props.round.teamMultiplier,
                                "x score bonus"),
                            " for their team")))));
    };
    return ContentExplanations;
}(React.Component));
export default ContentExplanations;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ContentExplanations.tsx
// module id = 279
// module chunks = 0